import { render, staticRenderFns } from "./TableFallDetectionAnalytics.vue?vue&type=template&id=3307fccc"
import script from "./TableFallDetectionAnalytics.vue?vue&type=script&lang=js"
export * from "./TableFallDetectionAnalytics.vue?vue&type=script&lang=js"
import style0 from "./TableFallDetectionAnalytics.vue?vue&type=style&index=0&id=3307fccc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports